import { validateSegmentActivation } from '../api/segmentValidation';

export default {

  methods: {

    async sendSegmentTrack(variable, place, component) {
      try {
        const response = await validateSegmentActivation({
          segment_variable: variable
        });

        if (response.data) {
          analytics.track(place,{
            component: component
          });
        }

      } catch (error) {
        console.log(error)
      }
    }
  },
}
